import React from "react";
const ShirtIcon = ({ kitColor = "#7CC4EB" }) => {
  return (
    <svg
      width="30"
      height="34"
      viewBox="0 0 51 60"
      fill=""
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_7730_2391)">
        <path
          d="M38.1362 31.7882C37.8824 34.0787 39.0805 38.089 38.6364 40.6755L38.5941 40.8869C38.2842 42.3175 38.8408 48.4774 39.3343 50.5354C36.1628 52.7907 31.18 54.2496 25.5346 54.2496C23.3697 54.2562 21.2102 54.0317 19.0929 53.5799C16.1611 52.9386 13.6309 51.8815 11.7425 50.5354C11.954 49.6615 12.2993 44.8549 12.4261 43.9951C12.5951 42.818 12.6586 41.7185 12.4755 40.8869C12.1371 39.3081 12.4826 38.1876 12.7503 35.7007C12.9124 34.1285 13.0392 32.6993 12.9406 31.7821C12.9124 31.5285 12.8842 31.2396 12.8561 30.9153C12.7715 30.0061 12.6939 28.8856 12.6235 27.8002C12.5318 26.4471 12.4544 25.1501 12.412 24.4312C12.3916 24.0576 12.3838 23.8391 12.3838 23.8391L11.298 25.9033C10.8963 25.8329 10.4876 25.7482 10.0933 25.6567C7.88301 25.0935 5.74502 24.2774 3.72168 23.2245C3.72168 23.2245 5.99808 16.9378 6.27392 15.6482C6.54793 14.3731 6.80847 7.72727 11.2698 6.66983C14.4766 5.90864 17.6551 4.28072 19.3247 3.20939C19.342 3.20155 19.3585 3.19212 19.3741 3.18121C19.9237 2.8288 20.3043 2.60951 20.4593 2.44127L20.5087 2.39185C20.5213 2.36997 20.5381 2.35081 20.5581 2.3355C20.5868 2.30317 20.6173 2.27256 20.6496 2.24382C21.1149 1.84915 21.8477 2.10988 22.7006 2.3988C23.6521 2.71589 25.5479 2.66668 25.5479 2.66668C25.5479 2.66668 27.4508 2.71609 28.4023 2.3988C29.3474 2.08171 30.1368 1.72235 30.5954 2.32835C31.054 2.93436 35.4016 5.62688 39.8345 6.68391C44.2958 7.74116 44.5566 14.3872 44.8314 15.6627C45.1134 16.9454 47.3837 23.239 47.3837 23.239C47.3837 23.239 43.6553 25.2688 39.8072 25.9242L38.7217 23.8595C38.7217 23.8595 38.5455 27.0733 38.3481 29.6378C38.2629 30.4633 38.1994 31.2245 38.1362 31.7882Z"
          fill={`${kitColor}`}
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.6995 3.17488C31.6763 3.16023 31.6532 3.14549 31.6302 3.13065C31.5704 3.09145 31.5096 3.05143 31.4488 3.01074C31.264 2.88552 31.0836 2.75381 30.9081 2.61583C30.7871 2.51902 30.6745 2.41235 30.5714 2.29694C30.5596 2.28257 30.5482 2.26822 30.5374 2.25391L30.54 2.26118C30.5264 2.24541 30.513 2.22948 30.4997 2.2134C30.437 2.15908 30.3671 2.1136 30.292 2.07823C29.8762 1.90018 29.3342 2.09034 28.7102 2.30928C28.6172 2.34192 28.5224 2.37519 28.4258 2.40798C27.4813 2.72507 25.5345 2.67525 25.5345 2.67525C25.5345 2.67525 23.6407 2.72568 22.69 2.40063L22.6499 2.38716C21.8135 2.10622 21.1235 1.87448 20.6735 2.24709C20.6363 2.27677 20.6022 2.31023 20.5718 2.34693C20.5727 2.34457 20.5736 2.3422 20.5744 2.33984C20.4731 2.45893 20.3374 2.57121 20.1846 2.6798C20.0908 2.74458 19.9827 2.81542 19.865 2.89091C19.8043 2.929 19.7428 2.96687 19.6814 3.00468C19.5705 3.07306 19.4598 3.14123 19.3545 3.21006C19.3472 3.21776 19.338 3.22317 19.3289 3.22854C19.3204 3.23357 19.3119 3.23857 19.3051 3.24538C19.2591 3.43616 19.2386 3.63216 19.244 3.82831C19.2791 4.45555 19.5954 5.03338 19.9629 5.562L20.0262 5.64653C20.6494 6.5254 21.4748 7.24157 22.4327 7.73468C23.3906 8.22776 24.4531 8.48329 25.5305 8.47973C23.522 7.45087 22.0278 5.74515 20.9001 3.94102C20.7321 3.68905 20.6091 3.4098 20.5367 3.11573C20.5346 3.10789 20.5325 3.10004 20.5306 3.09218C20.9135 2.83747 21.9319 3.07434 22.5892 3.36374C23.4843 3.75169 25.5353 3.68083 25.5353 3.68083C25.5353 3.68083 27.6575 3.75332 28.5524 3.36558C29.1883 3.08465 30.1632 2.8574 30.572 3.07385C30.4813 3.38335 30.3422 3.67658 30.1599 3.94268C29.0322 5.74701 27.538 7.45252 25.5293 8.48138C26.6068 8.48495 27.6693 8.22941 28.6273 7.73633C29.5852 7.24321 30.4106 6.52705 31.0338 5.64819L31.0971 5.56366C31.4646 5.03504 31.7809 4.45721 31.816 3.82997C31.8213 3.62321 31.8006 3.4166 31.7545 3.21498C31.7477 3.20817 31.7392 3.20317 31.7307 3.19814C31.7216 3.19277 31.7124 3.18736 31.7051 3.17966L31.6984 3.1753L31.6995 3.17488Z"
        fill="black"
        fillOpacity="0.1"
      />
      <defs>
        <filter
          id="filter0_d_7730_2391"
          x="0.228722"
          y="0.253521"
          width="50.6479"
          height="59.2359"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.74648" />
          <feGaussianBlur stdDeviation="1.74648" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_7730_2391"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_7730_2391"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default ShirtIcon;
